import { lazy } from 'react';

export const CountryList = lazy(() => import('./country/CountryList'));
export const StateList = lazy(() => import('./state/StateList'));
export const CityList = lazy(() => import('./city/CityList'));
export const CategoryList = lazy(() => import('./category/CategoryList'));
export const UnitList = lazy(() => import('./unit/UnitList'));
export const PincodeList = lazy(() => import('./pincode/PincodeList'));